import { COLOR, FONT, FONT_SIZE, THEME, THEME_DARK, __WEB__ } from '../../constants/styles';

module.exports = {
  container: {
    flex: 1,
    backgroundColor: __WEB__ ? COLOR.contrast : '#242e3f', // Specific color that matches the auth background image
  },
  iconContainer: {
    paddingTop: 5,
    alignItems: 'center',
  },
  brandingImage: {
    width: 88,
    height: 88,
  },

  inputsContainer: THEME.inputsContainer,
  errorContainer: __WEB__
    ? {
        justifyContent: 'center',
        height: 40,
        marginBottom: 20,
      }
    : {
        justifyContent: 'center',
        marginBottom: 15,
      },
  errorMessage: {
    ...FONT.regular,
    fontSize: 16,
    color: __WEB__ ? COLOR.error : COLOR.darkTheme.text,
    textAlign: 'center',
  },
  successMessage: {
    ...FONT.regular,
    fontSize: 16,
    color: __WEB__ ? COLOR.text : COLOR.darkTheme.text,
    textAlign: 'center',
  },
  bottomContainer: {},

  button: {
    marginVertical: 10,
    paddingVertical: 17,
    backgroundColor: __WEB__ ? '#2C426B' : COLOR.emphasis,
    borderRadius: 5,
  },
  buttonText: {
    ...FONT.bold,
    fontSize: __WEB__ ? FONT_SIZE.large : 22,
    color: 'white',
    textAlign: 'center',
  },

  termsContainer: {
    alignItems: 'center',
    paddingVertical: 10,
    marginHorizontal: __WEB__ ? 10 : 15,
    flexDirection: __WEB__ ? 'row' : 'column',
  },
  termsText: {
    ...FONT.regular,
    fontSize: __WEB__ ? FONT_SIZE.micro : FONT_SIZE.regular,
    color: __WEB__ ? COLOR.text : COLOR.darkTheme.text,
    marginTop: 5,
    textAlign: 'center',
  },
  termsButtonText: {
    ...FONT.regular,
    fontSize: __WEB__ ? FONT_SIZE.micro : FONT_SIZE.regular,
    color: __WEB__ ? COLOR.callToAction : COLOR.darkTheme.text,
    paddingLeft: __WEB__ ? 3 : 0,
    textDecorationLine: 'underline',
  },
};
